import { Link } from "react-router-dom";
import { G } from "@/brand";

export function Footer() {
  return (
    <footer data-testid="footer" style={{ borderTop: `1px solid ${G.border}33`, padding: "40px 5vw", textAlign: "center", background: G.black }}>
      <div style={{ display: "flex", gap: 20, justifyContent: "center", flexWrap: "wrap", marginBottom: 18 }}>
        <Link to="/privacy" data-testid="footer-privacy" className="mono" style={fl}>Privacy</Link>
        <Link to="/terms" data-testid="footer-terms" className="mono" style={fl}>Terms</Link>
        <Link to="/refunds" data-testid="footer-refunds" className="mono" style={fl}>Refunds</Link>
        <a href="mailto:Brocque@promptsavant.io" data-testid="footer-support" className="mono" style={fl}>Support</a>
      </div>
      <div className="mono" style={{ fontSize: 10, letterSpacing: "0.25em", color: G.goldDim, lineHeight: 2 }}>
        PROMPTSAVANT © 2026 · AI MUSIC PROMPT LIBRARY
      </div>
      <div className="mono" style={{ fontSize: 9, letterSpacing: "0.2em", color: "#5c4e22", marginTop: 8 }}>
        STANDALONE + VP I/O / VARIANT PLUG-IN · promptsavant.io
      </div>
    </footer>
  );
}

const fl = { color: G.muted, textDecoration: "none", fontSize: 10, letterSpacing: ".12em", textTransform: "uppercase" };
